module.exports = require('./dist/index');


//////////////////
// WEBPACK FOOTER
// ./~/react-spinners/index.js
// module id = 20
// module chunks = 168707334958949